import React, { lazy } from "react";

const BlueForrestLead = lazy(() =>
  import("../components/CheckoutTemplates/BlueforrestLeadTemplate.js")
);
const Skincare6pLead = lazy(() =>
  import("../components/CheckoutTemplates/Skincare6pLeadTemplate.js")
);
const SkincarebpLead = lazy(() =>
  import("../components/CheckoutTemplates/SkincarebpLeadTemplate.js")
);
const Skincare6pUpsell1 = lazy(() =>
  import("../components/UpsellTemplate/Skincare6pUpsell1Template.js")
);
const Skincare6pUpsell2 = lazy(() =>
  import("../components/UpsellTemplate/Skincare6pUpsell2Template.js")
);
const Skincare6pTherapy1 = lazy(() =>
  import("../components/LanderTemplate/Skincare6pTherapy1Template.js")
);
const Skincare6pTherapy2 = lazy(() =>
  import("../components/LanderTemplate/Skincare6pTherapy2Template.js")
);
const TestLander = lazy(() => import("../components/LanderTemplate/TestLander.js"));
const DickPillUpsell2 = lazy(() =>
  import("../components/UpsellTemplate/DickPillUpsell2Template.js")
);
const CSVUpload = lazy(() => import("../components/frontend/CSVUpload.js"));
const CustomerService = lazy(() => import("../components/Agent/CustomerService.js"));
const GuestCheckout = lazy(() =>
  import("../components/Agent/GuestCheckout.js")
);

export const checkoutRoutes = [
  { path: "/gskin-checkout", element: <Skincare6pLead /> },
  { path: "/skincarebpLead", element: <SkincarebpLead /> },
  { path: "/blueforrestLead", element: <BlueForrestLead /> },
  { path: "/skincare6pUpsell1", element: <Skincare6pUpsell1 /> },
  { path: "/skincare6pUpsell2", element: <Skincare6pUpsell2 /> },
  { path: "/skincare6pTherapy1", element: <Skincare6pTherapy1 /> },
  { path: "/skincare6pTherapy2", element: <Skincare6pTherapy2 /> },
  { path: "/test-lander", element: <TestLander /> },
  { path: "/dickPillUpsell2", element: <DickPillUpsell2 /> },
  { path: "/csv-upload", element: <CSVUpload /> },
  { path: "/cs", element: <CustomerService /> },
  { path: "/guest-checkout", element: <GuestCheckout /> },
];
